import { render, staticRenderFns } from "./ExportPdfSbac.vue?vue&type=template&id=779a1f73&scoped=true&"
import script from "./ExportPdfSbac.vue?vue&type=script&lang=js&"
export * from "./ExportPdfSbac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a1f73",
  null
  
)

export default component.exports